import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class BillingPricePlanDetails implements IController {

  pricePlanBundle: any;
  selectedProgramId: any;

  public currentNavItem: any;
  public programTemplates: any;
  public selectedTemplate: any;
  public selectedProgram: any;

  /* @ngInject */
  constructor(private $state, private PricePlanService) {
  }

  $onInit() {
    const statesArray = (this.$state.current.name).split('.')
    this.currentNavItem = statesArray[statesArray.length - 1]

    if (this.selectedProgramId) {
      this.selectedProgram = _.find(this.pricePlanBundle.entryList, (entry) => {
        return entry.id === this.selectedProgramId;
      })

      if (this.selectedProgram) {
        this.selectedTemplate = _.get(this.selectedProgram, 'parentProgramId') ? {
          type: _.get(this.selectedProgram, 'type'),
          id: _.get(this.selectedProgram, 'parentProgramId')
        } : undefined;
        this._getTemplates(this.selectedProgram.type);
      }
    }
  }

  onTemplateSelect(selectedTemplate) {
    this.selectedTemplate = {
      id: _.get(selectedTemplate, 'id'),
      type: _.get(selectedTemplate, 'pricePlanType'),
      parentPricePlanId: _.get(selectedTemplate, 'pricePlanId')
    };
    this.PricePlanService.updateProgramTemplate(this.selectedProgramId, selectedTemplate.id);

    // this.$state.go('.' , {programId: selectedProgramId}, {notify: true, reload: false});
  }

  changeState(stateName) {
    this.$state.go('^.' + stateName, {programId: this.selectedProgramId}, {notify: true, reload: false});
  }

  private _getTemplates(programType) {
    if (programType) {
      this.PricePlanService.getTemplatesByType(programType)
        .then((programTemplates) => {
          this.programTemplates = programTemplates;
        })
    }
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('billingPricePlanDetails', {
    bindings: {
      pricePlanBundle: '<',
      selectedProgramId: '<',
    },
    template: require('./billing-price-plan-details.html').default,
    controller: BillingPricePlanDetails
  });
